import dayjs from 'dayjs';
import weatherPlaceholderImg from '../../img/weather-placeholder.jpg';

class Weather {
  constructor() {
    this.currentTime = dayjs().format('h:mm a');

    this.weatherText = '';
    this.weather = '';
    this.weatherString = '';

    setTimeout(() => {
      this.initWeather();
    }, 500);
  }

  initWeather() {
    if (document.querySelector('.weather-atlas-wrapper')) {
      this.weatherText = document
        .querySelector('.weather-atlas-wrapper')
        .querySelector('.weather-atlas-body')
        .querySelector('.current_text').innerHTML;

      this.weather = document
        .querySelector('.weather-atlas-wrapper')
        .querySelector('.weather-atlas-body')
        .querySelector('.temp').innerHTML;

      this.weatherString = `<strong>${
        this.weather
      }F</strong> and <strong>${this.weatherText.toLowerCase()}</strong> at `;
    }

    this.text = `It's ${this.weatherString} <strong>${this.currentTime}</strong>.`;
    this.image = '';

    // pulled from the PHP.
    // eslint-disable-next-line
    const allSuggestions = suggestions;

    if (!allSuggestions.length) {
      this.renderText();
      return;
    }

    const usableSuggestions = allSuggestions.filter(suggestion =>
      this.filterSuggestion(suggestion),
    );

    if (!usableSuggestions.length) {
      this.renderText();
      this.image = weatherPlaceholderImg;
      this.renderImage();
      return;
    }

    if (usableSuggestions.length) {
      const randomSuggestion =
        usableSuggestions[Math.floor(Math.random() * usableSuggestions.length)];
      this.image = randomSuggestion.image ? randomSuggestion.image.url : weatherPlaceholderImg;
      this.renderImage();

      this.text += ` ${randomSuggestion.suggestion.replace('<p>', '').replace('</p>', '')}`;
      this.renderText();
    }
  }

  filterSuggestion(suggestion) {
    let weatherUsable = false;
    let timeUsable = false;

    // When this is okay to run.
    if (suggestion.weather) {
      const suggestionWeather = suggestion.weather;

      if (suggestionWeather.includes('any')) {
        weatherUsable = true;
      } else {
        weatherUsable = suggestionWeather.some(el => this.weatherText.toLowerCase().includes(el));
      }
    } else {
      weatherUsable = true;
    }

    // When this is okay to run.
    if (suggestion.time_of_day) {
      const suggestionTime = suggestion.time_of_day;

      const now24hr = dayjs().get('hour');

      if (suggestionTime.includes('any')) {
        timeUsable = true;
      } else {
        suggestionTime.forEach(times => {
          times = times.split('-');
          let startTime = times[0];
          let endTime = times[1];

          if (startTime.includes('am')) {
            startTime = startTime.split(' ')[0];
          } else {
            startTime = parseInt(startTime.split(' ')[0]) + 12;
          }
          if (endTime.includes('am')) {
            endTime = endTime.split(' ')[0];
          } else {
            endTime = parseInt(endTime.split(' ')[0]) + 12;
          }

          if (now24hr >= startTime && now24hr <= endTime) {
            timeUsable = true;
          }
        });
      }
    } else {
      timeUsable = true;
    }

    return weatherUsable && timeUsable;
  }

  renderText() {
    document.getElementById('weather-block').querySelector('.weather-text').innerHTML = this.text;
  }

  renderImage() {
    const imageElm = `<img class="weather__img" src="${this.image}" />`;
    document.getElementById('weather-block').querySelector('.weather-image').innerHTML = imageElm;
  }
}

export default Weather;
